import { get } from 'lodash';
import { useMoimCommonContext } from '../../contexts/index.mjs';
import 'react';
import 'react-intl';

var useSellerDisplayConfig = function useSellerDisplayConfig(key) {
  var config = useMoimCommonContext(function (state) {
    var _a;
    return (_a = state.sellerDisplayConfig) === null || _a === void 0 ? void 0 : _a[key];
  });
  return config !== null && config !== void 0 ? config : false;
};
var useSellerConfig = function useSellerConfig(key, path) {
  var config = useMoimCommonContext(function (state) {
    var _a;
    return get(state.sellerConfig, (_a = key !== null && key !== void 0 ? key : path) !== null && _a !== void 0 ? _a : "");
  });
  return config !== null && config !== void 0 ? config : false;
};
function useCurrentCurrencyRule(currency, fallbackCurrency) {
  return useMoimCommonContext(function (state) {
    var _a, _b;
    var currencyRule = (_a = state.currencyRules) === null || _a === void 0 ? void 0 : _a.find(function (rule) {
      return rule.currency === currency;
    });
    var fallbackCurrencyRule = (_b = state.currencyRules) === null || _b === void 0 ? void 0 : _b.find(function (rule) {
      return rule.currency === fallbackCurrency;
    });
    return currencyRule !== null && currencyRule !== void 0 ? currencyRule : fallbackCurrencyRule;
  });
}

export { useCurrentCurrencyRule, useSellerConfig, useSellerDisplayConfig };
